export default {
    savingsTimeSeries: [
        {
            year: 2021,
            age: 45.833333333333336,
            before: 10000,
            after: 10000,
            beforeFuture: 10000,
            afterFuture: 10000,
        },
        {
            year: 2022,
            age: 46.833333333333336,
            before: 9550,
            after: 10356,
            beforeFuture: 9693,
            afterFuture: 10512,
        },
        {
            year: 2023,
            age: 47.833333333333336,
            before: 9095,
            after: 10725,
            beforeFuture: 9370,
            afterFuture: 11049,
        },
        {
            year: 2024,
            age: 48.833333333333336,
            before: 8637,
            after: 11107,
            beforeFuture: 9031,
            afterFuture: 11615,
        },
        {
            year: 2025,
            age: 49.833333333333336,
            before: 8173,
            after: 11503,
            beforeFuture: 8675,
            afterFuture: 12209,
        },
        {
            year: 2026,
            age: 50.833333333333336,
            before: 7704,
            after: 11913,
            beforeFuture: 8300,
            afterFuture: 12834,
        },
        {
            year: 2027,
            age: 51.833333333333336,
            before: 7230,
            after: 12337,
            beforeFuture: 7906,
            afterFuture: 13490,
        },
        {
            year: 2028,
            age: 52.833333333333336,
            before: 6750,
            after: 12777,
            beforeFuture: 7492,
            afterFuture: 14180,
        },
        {
            year: 2029,
            age: 53.833333333333336,
            before: 6264,
            after: 13232,
            beforeFuture: 7056,
            afterFuture: 14906,
        },
        {
            year: 2030,
            age: 54.833333333333336,
            before: 5771,
            after: 13704,
            beforeFuture: 6599,
            afterFuture: 15668,
        },
        {
            year: 2031,
            age: 55.833333333333336,
            before: 5272,
            after: 14192,
            beforeFuture: 6118,
            afterFuture: 16470,
        },
        {
            year: 2032,
            age: 56.833333333333336,
            before: 4765,
            after: 14697,
            beforeFuture: 5612,
            afterFuture: 17313,
        },
        {
            year: 2033,
            age: 57.833333333333336,
            before: 4250,
            after: 15221,
            beforeFuture: 5081,
            afterFuture: 18198,
        },
        {
            year: 2034,
            age: 58.833333333333336,
            before: 3726,
            after: 15763,
            beforeFuture: 4522,
            afterFuture: 19130,
        },
        {
            year: 2035,
            age: 59.833333333333336,
            before: 3195,
            after: 16325,
            beforeFuture: 3935,
            afterFuture: 20108,
        },
        {
            year: 2036,
            age: 60.833333333333336,
            before: 2654,
            after: 16906,
            beforeFuture: 3318,
            afterFuture: 21137,
        },
        {
            year: 2037,
            age: 61.833333333333336,
            before: 2103,
            after: 17509,
            beforeFuture: 2669,
            afterFuture: 22218,
        },
        {
            year: 2038,
            age: 62.833333333333336,
            before: 1543,
            after: 18133,
            beforeFuture: 1987,
            afterFuture: 23355,
        },
        {
            year: 2039,
            age: 63.833333333333336,
            before: 971,
            after: 18779,
            beforeFuture: 1270,
            afterFuture: 24550,
        },
        {
            year: 2040,
            age: 64.83333333333333,
            before: 389,
            after: 19448,
            beforeFuture: 516,
            afterFuture: 25806,
        },
        {
            year: 2041,
            age: 65.83333333333333,
            before: 0,
            after: 20141,
            beforeFuture: 0,
            afterFuture: 27126,
        },
        {
            year: 2042,
            age: 66.83333333333333,
            before: 0,
            after: 20858,
            beforeFuture: 0,
            afterFuture: 28514,
        },
        {
            year: 2043,
            age: 67.83333333333333,
            before: 0,
            after: 21601,
            beforeFuture: 0,
            afterFuture: 29973,
        },
        {
            year: 2044,
            age: 68.83333333333333,
            before: 0,
            after: 22371,
            beforeFuture: 0,
            afterFuture: 31507,
        },
        {
            year: 2045,
            age: 69.83333333333333,
            before: 0,
            after: 23168,
            beforeFuture: 0,
            afterFuture: 33118,
        },
        {
            year: 2046,
            age: 70.83333333333333,
            before: 0,
            after: 23993,
            beforeFuture: 0,
            afterFuture: 34813,
        },
    ],
};
